import { CheckCircle, AlertTriangle, XCircle, ShieldAlert, Ban, ArrowRight } from "lucide-react";

const STATUS_CONFIG = {
  success: {
    title: "Survey Completed",
    description: "Thank you for your time. Your response has been recorded.",
    icon: CheckCircle,
    iconClass: "text-green-600",
    bgClass: "bg-green-600/10",
  },
  over_quota: {
    title: "Over Quota",
    description: "The required number of responses has already been collected.",
    icon: AlertTriangle,
    iconClass: "text-orange-500",
    bgClass: "bg-orange-500/10",
  },
  error: {
    title: "Something Went Wrong",
    description: "An unexpected error occurred. Please try again later.",
    icon: XCircle,
    iconClass: "text-red-600",
    bgClass: "bg-red-600/10",
  },
  terminated: {
    title: "Survey Terminated",
    description: "This survey is no longer accepting responses.",
    icon: Ban,
    iconClass: "text-red-600",
    bgClass: "bg-red-600/10",
  },
  security_terminated: {
    title: "Security Check Failed",
    description: "Your response was terminated due to security checks.",
    icon: ShieldAlert,
    iconClass: "text-red-600",
    bgClass: "bg-red-600/10",
  },
};

function SurveyStatusPage({ status = "success", message }) {
  const config = STATUS_CONFIG[status];
  const Icon = config.icon;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-3xl bg-background-muted p-8 shadow-lg  min-h-[350px] text-center flex items-center justify-center">
        <div>
          <div className={`mx-auto mb-6 flex size-24 items-center justify-center rounded-full ${config.bgClass}`}>
            <Icon className={`size-14 ${config.iconClass}`} />
          </div>

          <h1 className="text-2xl font-semibold text-foreground">{message ?? config.title}</h1>

          {!message && <p className="mt-3 text-sm text-muted-foreground">{config.description}</p>}
        </div>
      </div>
    </div>
  );
}

export default SurveyStatusPage;
